import { ConsumerLandingPage } from '~/portal/types/consumer'
import { PortalSettingsFormData } from '~/portal/types/portal'
import { LandingPagePreviewActionData, PreviewMode } from '~/portal/types/preview'
import { isMarkdownString, processMarkdown } from '~/portal/utils/shared/markdown'

export const PREVIEW_FORM_FIELD_NAME = 'isPreview'
export const PREVIEW_QUERY_PARAM_NAME = 'preview'

export const isPreviewMode = (previewParam?: string | null): previewParam is PreviewMode => (
  previewParam === PreviewMode.LANDING_PAGE || previewParam === PreviewMode.PRODUCT || previewParam === PreviewMode.TEMPLATE
)

export const isTemplatePreviewMode = (previewParam?: string | null): previewParam is PreviewMode.TEMPLATE => (
  previewParam === PreviewMode.TEMPLATE
)

export const isLandingPagePreviewMode = (previewParam?: string | null): previewParam is PreviewMode.LANDING_PAGE => (
  previewParam === PreviewMode.LANDING_PAGE
)

export const isProductPreviewMode = (previewParam?: string | null): previewParam is PreviewMode.PRODUCT => (
  previewParam === PreviewMode.PRODUCT
)

export const getLandingPagePreviewActionData = (formData: FormData): LandingPagePreviewActionData => {
  const isPreview = formData.get(PREVIEW_FORM_FIELD_NAME) === 'true'

  if (isPreview) {
    const previewData = Array.from(formData.entries())
      .filter(([key]) => key !== PREVIEW_FORM_FIELD_NAME)
      .reduce<PortalSettingsFormData>((result, [key, value]) => {
        result[key] = String(value || '')
        return result
      }, {})

    if (previewData.portalLandingPageDescription && isMarkdownString(previewData.portalLandingPageDescription)) {
      previewData.portalLandingPageDescription = processMarkdown(previewData.portalLandingPageDescription)
    }
    
    return { isPreview: true, previewData }
  }

  return { isPreview: false }
}

export const mergeLandingPagePreviewData = (landingPageData: ConsumerLandingPage, previewData?: PortalSettingsFormData): ConsumerLandingPage => {
  if (!previewData) {
    return landingPageData
  }

  return {
    ...landingPageData,
    name: previewData.portalName ?? landingPageData.name,
    description: previewData.portalLandingPageDescription ?? landingPageData.description,
    landingPageContent: previewData.portalLandingPageContent ?? landingPageData.landingPageContent,
    fontName: previewData.portalFont ?? landingPageData.fontName,
    accentColor: previewData.portalAccentColor ?? landingPageData.accentColor,
    accentColorDarkMode: previewData.portalAccentColorDarkMode ?? landingPageData.accentColorDarkMode,
    offline: previewData.portalOnlineStatus ? previewData?.portalOnlineStatus === 'false' : landingPageData.offline,
    faviconHref: previewData.portalFavIcon ?? landingPageData.faviconHref,
    heroImageHref: previewData.portalLandingPageHeroImage ?? landingPageData.heroImageHref,
    illustrationImageHref: previewData.portalLandingPageSecondaryImage ?? landingPageData.illustrationImageHref,
    logoImageHref: previewData.portalLogo ?? landingPageData.logoImageHref,
    faviconDarkModeHref: previewData.portalfaviconDarkMode ?? landingPageData.faviconDarkModeHref,
    heroImageDarkModeHref: previewData.portalLandingPageHeroImageDarkMode ?? landingPageData.heroImageDarkModeHref,
    illustrationImageDarkModeHref: previewData.portalLandingPageSecondaryImageDarkMode ?? landingPageData.illustrationImageDarkModeHref,
    logoImageDarkModeHref: previewData.portallogoDarkMode ?? landingPageData.logoImageDarkModeHref,
    footer: landingPageData.footer ? {
      ...landingPageData.footer,
      visible: previewData.portalFooterVisible !== undefined ? previewData.portalFooterVisible === 'true' : landingPageData.footer.visible,
      content: previewData.portalFooterContent ?? landingPageData.footer.content,
    } : undefined,
    customCss: previewData.portalCustomCss ?? landingPageData.customCss,
  }
}